import { Link } from "react-router-dom";
import classes from "./EarTrainerPage.module.css";

export default function EarTrainerHelp() {
  return <section className={classes.prose} aria-labelledby="ear-trainer-usage">
    <h2 id="ear-trainer-usage">How to use the Ear Trainer</h2>
    <ol>
      <li>Choose your instrument, scale and notes-per-string layout, then select a <strong>Practice diagram</strong>.
        The selected intervals must include the root, and the diagram needs a playable reference and at least two different pitches.</li>
      <li>Choose a <strong>Musical root</strong> and your training options. The root is your musical reference;
        <strong> Lowest root</strong> and <strong>Highest root</strong> select which root in the diagram you hear.</li>
      <li>Select <strong>Start Training!</strong> and listen to the root followed by the question note.</li>
      <li>Select the question's pitch on the fretboard. Click, tap or use the keyboard instructions below.</li>
      <li>Continue with each new question. Use <strong>Hear The Root</strong> or <strong>Hear The Question</strong> whenever
        you need to listen again, and <strong>Stop Training</strong> to return to exploration.</li>
    </ol>
    <p>The root is played when training begins or the root/diagram setup changes, including automatic changes.
      It is not replayed before every normal question. Outside training, clicking or tapping a position auditions its note.</p>

    <h3>Answers and visual hints</h3>
    <p>A correct answer shows green feedback and advances automatically after half a second. An incorrect answer
      shows red feedback and “Try again”; you can retry immediately. Neither action plays a separate answer sound.</p>
    <p>Any position producing the required pitch can be correct, including unmarked positions and the same pitch on
      another string. Scale markers are visual aids, not restrictions on answers. With <strong>Exact pitch</strong>,
      match the note and octave; <strong>Any octave</strong> also accepts the same note in another octave.</p>
    <p>Frets are relative to this diagram, rather than labelled absolute fret numbers on your instrument.</p>

    <h3>Adjust the challenge</h3>
    <p>Begin with <strong>All scale notes</strong> and <strong>Show interval</strong>. The first setting controls
      fretboard dots; the second gives a written interval-name hint. Try <strong>Hide interval</strong> to rely more on listening,
      then reduce the diagram markers to roots. You can also enable automatic root and diagram changes after a chosen number of questions.</p>

    <h3>Use the keyboard</h3>
    <p>Tab to the practice fretboard. Arrow keys move the outlined position without playing or answering;
      Enter or Space submits it during training and auditions it in exploration. Shift+Enter or Shift+Space auditions
      without answering, like Shift-click. The short correct-answer confirmation finishes before further positions can be submitted.</p>
    <p>For more background, read <Link to="/blog/ear-training-for-guitarists-why-bother">Ear Training For Guitarists — Why Bother?</Link>.</p>
  </section>;
}
